import MetaDataItem from './MetaDataItem';

export default MetaDataItem;
